import { Typography } from '@mui/material';
import { useMemo } from 'react';
import useSWR from 'swr';

import { SERVICES } from '@shared/constants/apiConfig';
import { IPeriod } from '@shared/interfaces';
import { TabsPageHeader } from '@styles/Tools/LenderControl/LenderControlsHeaderStyles';

import { Wrapper } from '@styles/CommonStyles';
import { LoaderBackdrop } from '@shared/components/LoaderBackdrop';
import { ITeamTypeType } from './interfaces';
import { TeamManagerTabs } from './tabs';

export const TeamManager = () => {
  const { data: periods = [], isLoading: isPeriodsLoading } = useSWR<IPeriod[]>(`/${SERVICES.USER}/period`);
  const { data: teamTypes = [], isLoading: isTeamTypeLoading } = useSWR<ITeamTypeType[]>(`/${SERVICES.USER}/teamType`);

  const sortedPeriods = useMemo(
    () => periods.sort((periodOne, periodTwo) => (periodOne.fromDate < periodTwo.fromDate ? 1 : -1)),
    [periods]
  );

  return (
    <Wrapper>
      <LoaderBackdrop open={isPeriodsLoading || isTeamTypeLoading} />

      <TabsPageHeader>
        <Typography variant="h3">Team Manager</Typography>
      </TabsPageHeader>

      <TeamManagerTabs periods={sortedPeriods} teamTypes={teamTypes} />
    </Wrapper>
  );
};
